import { GridSortModel } from '@mui/x-data-grid';
import { TEntityListResponse, TAreaSummaryResBody } from '@poseidon-city/api-sdk';
import { useQuery } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { useCompanyId } from '../../contexts/CompaniesAreasContext';
import { getQuerySortString } from '../device-types/list-device-by-device-type';

type TCompanyAreasListHook = {
  isError: boolean;
  isLoading: boolean;
  data: TEntityListResponse<'area', TAreaSummaryResBody> | undefined;
};

function useGetCompanyAreas(
  limit: number,
  page: number,
  queryOptions: { sortModel: GridSortModel }
): TCompanyAreasListHook {
  const sdk = useApiSDK();

  const { companyId } = useCompanyId();

  const sortStr = getQuerySortString(queryOptions);

  if (!companyId) {
    throw new Error('No CompanyId provided');
  }

  const { isError, isLoading, data } = useQuery({
    queryKey: ['company-areas', companyId.id, sortStr],
    queryFn: () => {
      if (companyId.id === 'ALL') {
        return sdk.areas.list(limit, page, sortStr);
      } else {
        return sdk.companies.listCompanyAreas(companyId.id, limit, page, sortStr);
      }
    },
    cacheTime: 0,
    staleTime: 0,
  });
  return { isError, isLoading, data };
}

export { useGetCompanyAreas };
